import Navlink from "../../component/navlink/Navlink";

const Clients = ({ children }) => {
  return (
    <>
      <Navlink />
      {children}
    </>
  );
};

export default Clients;
